import { SeoHead, organizationLd, webSiteLd, faqLd } from '../seo';

const faqs = [
  {
    q: 'Is parksy.rent free to use?',
    a: 'Yes, completely free. No signup, no app download, no brokerage fees. We run minimal ads to cover server costs.',
  },
  {
    q: 'Do I need to create an account?',
    a: 'No. Parksy is anonymous. We identify your pins by your IP address (hashed) so you can edit or delete them later.',
  },
  {
    q: 'How does matching work?',
    a: "Our system scans active seeker pins and parking spot listings daily. When a seeker and listing are within 3 km and compatible on vehicle type, budget, and features, we email both parties with each other's contact details.",
  },
  {
    q: 'Is my phone number and email visible on the map?',
    a: "Never. Your contact details are stored privately and shared only via match emails with compatible listings or seekers.",
  },
  {
    q: 'What vehicle types are supported?',
    a: 'Cars, bikes, scooters, and bicycles. Each has different pricing and space requirements.',
  },
  {
    q: 'Can I list commercial parking lots?',
    a: 'Yes. Commercial lots, residential driveways, apartment slots, garages, open plots, and street parking can all be listed.',
  },
  {
    q: 'How do you prevent fake listings?',
    a: 'We use multiple layers: IP rate limits, price sanity checks, community reports, statistical outlier detection, and report-bomb protection. Pins with 3+ reports are automatically hidden.',
  },
  {
    q: 'How do I report a pin that looks wrong?',
    a: 'Open the pin and tap the 🚩 icon below the share buttons. Pick a reason (wrong location, wrong info, duplicate, spam, etc.) and submit. If 3 different people report the same pin, it is automatically hidden.',
  },
  {
    q: 'What is a "price transparency" pin?',
    a: "Even if you're not renting out your spot, you can anonymously share what you pay for parking. This helps others understand real market rates in any area.",
  },
];

export default function FAQ() {
  return (
    <>
      <SeoHead
        title="Frequently Asked Questions — Parksy.rent"
        description="Common questions about how Parksy works: matching, privacy, free pricing, no signup, anti-fraud, and how to list or find parking."
        canonical="https://parksy.rent/faq"
        ogImage="https://parksy.rent/og/faq.png"
        schemas={[organizationLd(), webSiteLd(), faqLd(faqs.map((f) => ({ question: f.q, answer: f.a })))]}
      />
      <div className="max-w-3xl mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">Frequently Asked Questions</h1>
        <div className="space-y-6">
          {faqs.map((faq, i) => (
            <div key={i} className="bg-white rounded-xl shadow-sm border p-5">
              <h2 className="font-semibold text-gray-900 mb-2">{faq.q}</h2>
              <p className="text-gray-600">{faq.a}</p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
